import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.css']
})
export class AccessibilityComponent implements OnInit {
  isHighContrast = false;
  fontSize = 16;
  isReducedMotion = false;
  isDyslexicFriendly = false;
  showAccessibilityPanel = false;

  ngOnInit(): void {
    this.loadAccessibilitySettings();
  }

  toggleAccessibilityPanel(): void {
    console.log('Toggle accessibility panel clicked');
    this.showAccessibilityPanel = !this.showAccessibilityPanel;
    console.log('Panel state:', this.showAccessibilityPanel);
  }

  toggleHighContrast(): void {
    console.log('Toggle high contrast clicked');
    this.isHighContrast = !this.isHighContrast;
    if (this.isHighContrast) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }
    this.saveAccessibilitySettings();
  }

  increaseFontSize(): void {
    if (this.fontSize < 24) {
      this.fontSize += 2;
      this.applyFontSize();
    }
  }

  decreaseFontSize(): void {
    if (this.fontSize > 12) {
      this.fontSize -= 2;
      this.applyFontSize();
    }
  }

  resetFontSize(): void {
    this.fontSize = 16;
    this.applyFontSize();
  }

  private applyFontSize(): void {
    document.documentElement.style.fontSize = this.fontSize + 'px';
    this.saveAccessibilitySettings();
  }

  toggleReducedMotion(): void {
    this.isReducedMotion = !this.isReducedMotion;
    if (this.isReducedMotion) {
      document.body.classList.add('reduced-motion');
    } else {
      document.body.classList.remove('reduced-motion');
    }
    this.saveAccessibilitySettings();
  }

  toggleDyslexicFriendly(): void {
    this.isDyslexicFriendly = !this.isDyslexicFriendly;
    if (this.isDyslexicFriendly) {
      document.body.classList.add('dyslexic-friendly');
    } else {
      document.body.classList.remove('dyslexic-friendly');
    }
    this.saveAccessibilitySettings();
  }

  // Nuevo método para restablecer todos los estilos a valores por defecto
  resetAllAccessibilitySettings(): void {
    console.log('Resetting all accessibility settings to default');
    
    // Restablecer variables del componente
    this.isHighContrast = false;
    this.fontSize = 16;
    this.isReducedMotion = false;
    this.isDyslexicFriendly = false;
    
    // Remover todas las clases de accesibilidad del body
    document.body.classList.remove('high-contrast');
    document.body.classList.remove('reduced-motion');
    document.body.classList.remove('dyslexic-friendly');
    
    // Restablecer tamaño de fuente por defecto
    document.documentElement.style.fontSize = '16px';
    
    // Limpiar localStorage
    localStorage.removeItem('accessibilitySettings');
    
    // Guardar configuración por defecto
    this.saveAccessibilitySettings();
    
    console.log('All accessibility settings reset to default');
  }

  private saveAccessibilitySettings(): void {
    const settings = {
      isHighContrast: this.isHighContrast,
      fontSize: this.fontSize,
      isReducedMotion: this.isReducedMotion,
      isDyslexicFriendly: this.isDyslexicFriendly
    };
    localStorage.setItem('accessibilitySettings', JSON.stringify(settings));
  }

  private loadAccessibilitySettings(): void {
    const saved = localStorage.getItem('accessibilitySettings');
    if (saved) {
      try {
        const settings = JSON.parse(saved);
        this.isHighContrast = settings.isHighContrast || false;
        this.fontSize = settings.fontSize || 16;
        this.isReducedMotion = settings.isReducedMotion || false;
        this.isDyslexicFriendly = settings.isDyslexicFriendly || false;

        // Aplicar configuraciones guardadas
        if (this.isHighContrast) {
          document.body.classList.add('high-contrast');
        }
        if (this.isReducedMotion) {
          document.body.classList.add('reduced-motion');
        }
        if (this.isDyslexicFriendly) {
          document.body.classList.add('dyslexic-friendly');
        }
        this.applyFontSize();
      } catch (error) {
        console.error('Error loading accessibility settings:', error);
      }
    }
  }

  // Navegación por teclado
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.showAccessibilityPanel = false;
    }
  }
}
